import { WSServiceError } from "../../../utils/serviceHelper";
import { useWSQuery } from "../../helpers";
import { useQueryRequirementDefinitionsSettings } from "./useQueryRequirementDefinitionsSettings";
import { useQueryRequirementDefinitionListAll } from "./useQueryRequirementDefinitionListAll";
import { ExtendedRequirementDefinition } from "./useQueryExtendedRequirementDefinition";
import { RequirementDefinitionListQueryParams } from "./useQueryRequirementDefinitionList";

export const QUERY_EXTENDED_REQUIREMENT_DEFINITIONS =
  "QUERY_EXTENDED_REQUIREMENT_DEFINITIONS";

export const useQueryExtendedRequirementDefinitions = (
  fetch: Parameters<typeof useQueryRequirementDefinitionsSettings>[0]["fetch"],
  params?: RequirementDefinitionListQueryParams
) => {
  const queryRequirements = useQueryRequirementDefinitionListAll(params);
  const querySettings = useQueryRequirementDefinitionsSettings({
    enabled: queryRequirements.isSuccess,
    requirementDefinitions: queryRequirements.data || [],
    fetch
  });

  return useWSQuery<ExtendedRequirementDefinition[], WSServiceError>(
    [
      QUERY_EXTENDED_REQUIREMENT_DEFINITIONS,
      fetch,
      queryRequirements.dataUpdatedAt
    ],
    () => {
      const requirements = queryRequirements.data || [];
      const extendedRequirements = requirements.map(requirement => ({
        ...requirement,
        dataSource: querySettings.data?.[requirement.dataSourceId!]
      }));

      return Promise.resolve(extendedRequirements);
    },
    {
      enabled: queryRequirements.isSuccess && querySettings.isFetched
    }
  );
};
